import { Dispatch, ReactElement, SetStateAction } from 'react'

import { useIntl } from 'react-intl'

import { Button, THEME, ThemeProvider } from '@themenu/design-system'

import { ErrorProps } from '../../components/AlertError'
import { requestStorageAccess } from '../../services/accessStorage'

export type StorageAccessRequestButtonProps = {
  onSuccess: () => void
  onError: Dispatch<SetStateAction<ErrorProps | null>>
}

export const StorageAccessRequestButton = ({ onSuccess, onError }: StorageAccessRequestButtonProps): ReactElement => {
  const intl = useIntl()

  const onRequestAccessStorage = async (): Promise<void> => {
    try {
      await requestStorageAccess()
      onSuccess()
    } catch {
      onError({
        title: 'storage_access_request_page.error.title',
        message: 'storage_access_request_page.error.message',
      })
    }
  }

  return (
    <ThemeProvider theme={THEME.LIGHT}>
      <Button onClick={onRequestAccessStorage} variant="contrast" fullWidth>
        {intl.formatMessage({ id: 'storage_access_request_page.button' })}
      </Button>
    </ThemeProvider>
  )
}
